/**
 * A bordered, sideways-scrolling frame for the console's wide tables (#2830).
 * The border shows where the table ends on a phone, and the hint line says
 * more columns sit to the right. The frame takes focus, so a keyboard user
 * can scroll it. The page itself never scrolls sideways.
 */
import { useId } from "react";

export function ScrollFrame({ label, children }: { label: string; children: React.ReactNode }) {
  const hintId = useId();
  return (
    <div className="min-w-0">
      <p
        id={hintId}
        className="mb-1 text-xs text-fg-faint sm:hidden"
        data-testid="admin-table-scroll-hint"
      >
        Swipe the table sideways for more columns.
      </p>
      <section
        aria-label={label}
        aria-describedby={hintId}
        // biome-ignore lint/a11y/noNoninteractiveTabindex: a scroll region must take focus to scroll by keyboard
        tabIndex={0}
        className="max-w-full overflow-x-auto rounded-md border border-border focus-visible:outline focus-visible:outline-2 focus-visible:outline-accent"
        data-testid="admin-table-scroll"
      >
        {children}
      </section>
    </div>
  );
}
